import { render, staticRenderFns } from "./ProjectListDialog.vue?vue&type=template&id=0968ecba&"
import script from "./ProjectListDialog.vue?vue&type=script&lang=js&"
export * from "./ProjectListDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProjectListDialog.vue?vue&type=style&index=0&id=0968ecba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports